
export default function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Modifier l’adresse',
        setAsDefault: 'Définir comme l’adresse de livraison par défaut',
        cancel: 'Annuler',
        confirm: 'Utiliser cette adresse'
    };

    return resources[label];
}
